/* eslint-disable no-unused-vars */
import { Icon } from '@iconify/react';
import { Lock } from '@mui/icons-material';
import CancelIcon from '@mui/icons-material/Cancel';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import MessageIcon from '@mui/icons-material/Message';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import PersonIcon from '@mui/icons-material/Person';
import RamenDiningIcon from '@mui/icons-material/RamenDining';

import { PATH_DASHBOARD, PATH_ROLE_LOGIN } from '../../../routes/paths';

const navConfig = [
  {
    items: [
      { title: 'Dashboard', path: '/dashboard/home', icon: <Icon icon="ri:dashboard-line" /> },
      { title: 'Profile', path: '/dashboard/editadmin', icon: <PeopleAltIcon /> },
      { title: 'My Listings', path: PATH_DASHBOARD.listing.listing, icon: <FormatListBulletedIcon /> },
      { title: 'Bookings', path: PATH_DASHBOARD.booking.booking, icon: <Icon icon="ri:dashboard-line" /> },

      {
        title: 'AirMail\u2122', // Unicode for ™
        path: '/dashboard/chat',
        icon: <MessageIcon />,
      },

      { title: 'Users', path: PATH_DASHBOARD.user.user, icon: <PersonIcon /> },
      // { title: 'Host', path: PATH_DASHBOARD.host.host, icon: <GiteIcon /> },
      // { title: 'Facilities', path: PATH_DASHBOARD.facility.facility, icon: <PeopleAltIcon /> },
      { title: 'Features', path: PATH_DASHBOARD.amenity.amenity, icon: <RamenDiningIcon /> },

      {
        title: 'Cancelation Policies',
        path: PATH_DASHBOARD.cancellationPolicy.cancellationPolicy,
        icon: <CancelIcon />,
      },
      {
        title: 'Restaurants',
        path: '/dashboard/restaurants',
        icon: <CancelIcon />,
      },

      { title: 'Logout', path: PATH_ROLE_LOGIN.admin, icon: <Lock /> },
    ],
  },
];

export default navConfig;
